var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.30238 6.95068L6.24023 6.88854L6.17809 6.95068L3.83111 9.29766C3.65111 9.47766 3.36244 9.47766 3.18244 9.29766C3.00245 9.11766 3.00245 8.82899 3.18244 8.64899L5.52942 6.30201L5.59157 6.23987L5.52942 6.17772L3.18244 3.83075C3.00245 3.65075 3.00245 3.36208 3.18244 3.18208C3.36244 3.00208 3.65111 3.00208 3.83111 3.18208L6.17809 5.52906L6.24023 5.5912L6.30238 5.52906L8.64936 3.18208C8.82935 3.00208 9.11803 3.00208 9.29802 3.18208C9.47802 3.36208 9.47802 3.65075 9.29802 3.83075L6.95105 6.17772L6.8889 6.23987L6.95105 6.30201L9.29802 8.64899C9.47766 8.82862 9.47488 9.1208 9.29802 9.29766C9.11803 9.47766 8.82935 9.47766 8.64936 9.29766L6.30238 6.95068Z",
    fill: "#767678",
    stroke: "#F5F2FF",
    strokeWidth: 0.17577
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36f3163286e3e483b39ea70293241a91.svg";
export { ForwardRef as ReactComponent };